import axios from "axios"
import { useAuthStore } from "@/stores/auth"

export const axiosWrapper = {
  get: (url: string) => axiosInstance.get(url),
  post: (url: string, body: any) => axiosInstance.post(url, body),
  put: (url: string, body: any) => axiosInstance.put(url, body),
  patch: (url: string, body: any) => axiosInstance.patch(url, body),
  delete: (url: string) => axiosInstance.delete(url),
  blob: (url: string) => axiosInstance.get(url, { responseType: "blob" }),
}

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
})

axiosInstance.interceptors.request.use(
  (config) => {
    const authStore = useAuthStore()
    const bearerToken = authStore.bearerToken
    if (bearerToken) {
      config.headers.Authorization = `Bearer ${bearerToken}`
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

axiosInstance.interceptors.response.use(
  (response) => {
    if (response.config.responseType === "blob") {
      return response
    } else {
      return response.data
    }
  },
  (error) => {
    const { response } = error
    const authStore = useAuthStore()

    if ([401, 403].includes(response?.status)) {
      authStore.logout()
    }

    return Promise.reject(response?.data?.error || error)
  }
)
